<template>
  <div class="check-work-body">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
        <div style="width: 30px;display: inline-block;"></div>
      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
          <el-table-column prop="title" label="标题" align="center" width="240"></el-table-column>
          <el-table-column prop="image" label="图片" align="center" width="180"></el-table-column>
          <el-table-column prop="channel_id" label="菜单栏ID" align="center" width="180"></el-table-column>
          <el-table-column prop="link" label="链接" align="center"></el-table-column>
          <el-table-column prop="sort" label="权重" align="center"></el-table-column>
          <el-table-column prop="views" label="浏览" align="center" width="180"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" align="center" width="180"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" align="center" width="180"></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCmsArticle(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="项目编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="菜单ID" prop="title">
            <el-input class="form-input" v-model="form.channel_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input class="form-input" v-model="form.title" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="简介" prop="description">
            <el-input type="textarea" rows="5" v-model="form.description" autocomplete="off" style="width: 450px;"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <!--        <el-input v-model="form.content" autocomplete="off"></el-input>-->
            <HtmlEditor :data-content="form.content" style="width: 500px" :content="form.content" :host-url="host_url" :upload-url="upload_url" @onEditor="onEditor" />
          </el-form-item>
          <el-form-item label="图片" prop="image">
            <UploadFileSysc v-model="form.image" :host-url="host_url" :upload-url="uploadUrl"></UploadFileSysc>
          </el-form-item>
          <el-form-item label="链接" prop="link">
            <el-input class="form-input" v-model="form.link" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input class="form-input" v-model="form.sort" autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import UploadFileSysc from "./components/UploadFileSysc";
import HtmlEditor from "./components/HtmlEditor";

export default {
  name:"CmsChannel",
  components: {HtmlEditor, UploadFileSysc, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        description:"",
        image:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      error_list:[],
      error_show_status:false,
      upload_url:""
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.upload_url=this.host_url+"CmsArticle/uploadFile";
    this.uploadUrl=this.host_url+"CmsArticle/uploadFile";
    // this.getList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        description:"",
        image:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      CommonHelp.get("admin/CmsArticle/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      if(!item) {
        this.form = this.getFormData({})
      } else {
        this.form = item
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          console.log(data)
          CommonHelp.post("admin/CmsArticle/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      CommonHelp.post("admin/CmsArticle/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    deleteCmsArticle(item){
      var that=this;
      CommonHelp.post("admin/CmsArticle/del", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    onEditor({ editor, html, text }){
      this.form.content=html;
      this.form.description=text;
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Cms/CmsArticle.vue